import {isTouch} from './touch';

const menuList = document.getElementById('menu-list');
const menuButton = document.getElementById('menu-toggle');

menuButton.addEventListener('click', () => {
  menuList.classList.toggle('visible');
});

const navigationLinksWithChildren = document.querySelectorAll('.navigation-link-with-children');
let currentElement = null;

navigationLinksWithChildren.forEach(element => {
  element.addEventListener('click', event => {
    if (isTouch() && currentElement !== element) {
      currentElement = element
      event.preventDefault()
    }
  })
});